// extracted by extract-css-chunks-webpack-plugin
module.exports = {"message":"batch-entry-close-batch-confirm__message___9Ib1H","container":"batch-entry-close-batch-confirm__container___2KBq8","left":"batch-entry-close-batch-confirm__left___3pZ-n","right":"batch-entry-close-batch-confirm__right___1EBkC","large":"batch-entry-close-batch-confirm__large___SS8VR","dollar":"batch-entry-close-batch-confirm__dollar___2SYNW"};
    if(module.hot) {
      // 1695336326076
      var cssReload = require("../../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  